module.exports = window.XMLHttpRequest;